import { useMutation, useQueryClient } from "@tanstack/react-query";
import { priorityService } from "@/services/priorityService";
import type { IClaimAssignment } from "@/types";

/** Claiming moves a deliverable out of the candidate pool, so every list that splits on it refetches. */
export const useClaimPriority = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ pid, ...data }: IClaimAssignment & { pid: string }) => priorityService.claimAssignment(pid, data),
    onSuccess: () => {
      for (const key of [["priorities"], ["ppps"], ["my-onething"], ["team-priorities"], ["accountability"]]) {
        qc.invalidateQueries({ queryKey: key });
      }
    },
  });
};
